import React, { useState } from 'react';
import { Button, Modal } from 'antd';

const DetailRewardPopup: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button
                onClick={showModal}
                style={{
                    background: 'linear-gradient(264.28deg, #ffc7c7 -38.2%, #fe2727 103.12%)',
                    fontFamily: 'conthrax',
                    color: 'white',
                    border: 'none',
                }}>
                Chi tiết
            </Button>
            <Modal title="Chi tiết" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
                <div style={{
                    height: '70vh',
                    overflowY: 'scroll',
                }}>
                    <h2>Cơ cấu giải thưởng</h2>
                    <p>1 Giải Nhất: <b>5.000.000 VND</b>, kỷ niệm chương, trở thành Đại Sứ Truyền Thông của chương trình TEDxFPTUniversityHCMC 2024, chứng nhận bản cứng, bộ KIT kỷ niệm từ trường Đại học FPT, quà từ Nhà Tài Trợ.</p>
                    <p>1 Giải Nhì: <b>3.000.000 VND</b>, chứng nhận bản cứng, bộ KIT kỷ niệm từ trường Đại học FPT, quà từ Nhà Tài Trợ.</p>
                    <p>1 Giải Ba: <b>2.000.000 VND</b>, chứng nhận bản cứng, bộ KIT kỷ niệm từ trường Đại học FPT, quà từ Nhà Tài Trợ.</p>
                    <p>1 Giải Tiềm Năng (do Ban Giám Khảo bình chọn): <b>500.000 VND</b>, chứng nhận bản cứng, bộ KIT kỷ niệm từ trường Đại học FPT, quà từ Nhà Tài Trợ.</p>
                    <p>1 Giải Thí Sinh Được Yêu Thích Nhất (do Khán Giả bình chọn): <b>500.000 VND</b>, chứng nhận bản cứng, bộ KIT kỷ niệm từ trường Đại học FPT, quà từ Nhà Tài Trợ.</p>

                    <br />
                    <h2>Quyền lợi của thí sinh</h2>
                    <p>Quán quân sẽ Trở Thành Đại Sứ Truyền Thông TEDxFPTUniversityHCMC 2024.</p>
                    <p>100% thí sinh đăng ký tham gia cuộc thi sẽ nhận được CHỨNG NHẬN BẢN MỀM.</p>
                    <p>
                        TOP 30 thí sinh lọt vào Vòng Bán Kết sẽ nhận được chứng nhận BẢN CỨNG từ Ban Tổ Chức cuộc thi,
                        được trao nhận tại ngày diễn ra chung kết và nhận nhiều phần quà hấp dẫn đến từ Nhà Tài Trợ chương trình.
                    </p>
                    <p>
                        TOP 30 thí sinh sẽ được Ban Tổ Chức mời đến trường Đại học FPT Thành Phố Hồ Chí Minh để thực hiện phần thi Video Shooting.
                    </p>
                    <p>
                        TOP 30 thí sinh sẽ được Ban Tổ Chức mời đến tham dự và trao thưởng chứng nhận bản cứng ở Vòng Chung Kết.
                    </p>
                    <p>
                        TOP 10 chung cuộc được mời gia đình, bạn bè và người thân đến tham dự (mỗi thí sinh được mời tối đa 5 khách mời).
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default DetailRewardPopup;